export default function dashboard(app) {
  {
    if (location.pathname === "/panel") {
      // only for dashboard
      if (document.readyState !== "loading") {
        openTopUpFunds();
      } else {
        document.addEventListener("DOMContentLoaded", openTopUpFunds);
      }
    }
  }

  function urlParameterExists(field) {
    const url = window.location.href;
    return url.indexOf("?" + field) !== -1 || url.indexOf("&" + field) !== -1;
  }

  /**
   * Open top-up funds pop up
   */
  function openTopUpFunds() {
    if (urlParameterExists("top_up_funds")) {
      let btn,
        counter = 0;

      let interval = setInterval(function () {
        btn = document.querySelector(".top-up-funds-btn");

        if (btn) {
          btn.click();
          clearUrl(interval);
        }
        if (counter >= 20) {
          clearUrl(interval);
        }
        counter++;
      }, 550);
    }
  }

  function clearUrl(interval) {
    clearInterval(interval);
    history.pushState("", document.title, window.location.pathname);
  }
}
